import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component to automatically reset scroll height when navigating to new page
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

export default ScrollToTop;
